import React, {lazy, useContext} from "react";
import UserContext from "../../store/userContext";
const Loginbox = lazy(()=>import("../ui/functional/Loginbox"));


export default function AdminRequireLogin({requiredRole, minRole, sendToRefreshBool, children }) {
	const user = useContext(UserContext);
	if (user.isLoadingAuth) return <div>Laster...</div>

	if (!user.isLoggedIn) {
		return (
			<div className={'centered'}>
				<p style={{color:"darkred"}}><b>Du må logge inn for å få tilgang til denne siden.</b></p>
				<Loginbox sendToRefreshBool={sendToRefreshBool}/>
			</div>
		);
	}


	if (minRole&& user.role < minRole) {
		return <div className={'centered'}>
			<p>Brukeren mangler rettigheter</p>
		</div>;
	}else if(requiredRole&& !user?.roles?.includes(requiredRole)) {
		return <div className={'centered'}>
			<p>Brukeren mangler rettigheter</p>
		</div>;
	}
	return <>{children}</>;
}